import { HoverPopover } from "@/components/atoms/HoverPopover";
import { RequiredPermissionsPopOverProps } from ".";
import { BorderBox } from "@/components/atoms/BorderBox";
import { capitalize } from "lodash";

export function RequiredPermissionsPopOver(props: Readonly<RequiredPermissionsPopOverProps>) {
    console.log("RequiredPermissionsPopOver rendered with props:", props);
    return (
        <HoverPopover
            onHover={true}
            popoverContentProps={{
                className: "w-full max-w-lg p-0"
            }}
            content={
                <BorderBox variant='danger' className="">
                    <div className="flex flex-col">
                        <p>You don't meet required permissions to access this feature.</p>
                        {props.requiredPermissions.length > 0 &&
                            <>
                                <span className="mt-2 font-semibold">Required permissions:</span>
                                <ul className="list-disc list-inside">
                                    {props.requiredPermissions.map((permission) => (
                                        <li key={permission}>{capitalize(permission.replaceAll('_', ' '))}</li>
                                    ))}
                                </ul>
                            </>
                        }
                        {props.roles && props.requiredPermissions.length > 0 && (
                            <span className="mt-2 font-semibold">or</span>
                        )}
                        {props.roles && (
                            <div>
                                <span className="mt-2 font-semibold">Required role(s):</span>
                                <ul className="list-disc list-inside">
                                    {Array.isArray(props.roles) ? props.roles.map((role) => (
                                        <li key={role}>{role}</li>
                                    )) : <li>{props.roles}</li>}
                                </ul>
                            </div>
                        )}
                    </div>
                </BorderBox>
            }
        >
            <div className="pointer-events-none opacity-80 grayscale-[0.4]">
                {props.children}
            </div>
        </HoverPopover>
    )
}